import { pdf } from '@react-pdf/renderer';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../Firebase Functions/firebase';
import axios from 'axios';
import PayoutRequestPDF from '../PDF Functions/PayoutPDF';

const quickbaseApi = axios.create({
  baseURL: 'https://api.quickbase.com/v1',
  headers: {
    'QB-Realm-Hostname': process.env.REACT_APP_QB_REALM_HOSTNAME,
    'Authorization': `QB-USER-TOKEN ${process.env.REACT_APP_QB_API_KEY}`,
    'Content-Type': 'application/json',
  },
});

const findQuickBaseRecordIdByIncidentId = async (incidentId) => {
  const queryPayload = {
    from: 'buz6rhchu',
    select: [3, 12],
    where: `{12.EX.'${incidentId}'}`,
  };

  const response = await quickbaseApi.post('/records/query', queryPayload);
  const records = response.data?.data || [];

  if (records.length > 0) {
    return records[0][3].value;
  }

  return null;
};

const UploadPayoutRequestToQuickBase = async (incidentId) => {
  try {
    // Step 1: Fetch payout request data from Firestore
    const docRef = doc(db, 'payoutRequests', incidentId);
    const docSnap = await getDoc(docRef);

    if (!docSnap.exists()) {
      throw new Error('Payout request form not found in Firebase.');
    }

    const formData = docSnap.data();

    // Step 2: Render PDF and convert to Base64
    const pdfBlob = await pdf(<PayoutRequestPDF formData={formData} />).toBlob();
    const blobToBase64 = (blob) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result.split(',')[1]);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    
    const pdfBase64 = await blobToBase64(pdfBlob);
    

    // Step 3: Find QuickBase record for incident
    const existingRecordId = await findQuickBaseRecordIdByIncidentId(incidentId);

    // Step 4: Construct record payload
    const record = {
      13: {
        value: {
          fileName: `PayoutRequest_${incidentId}.pdf`,
          data: pdfBase64,
        },
      },
    };

    if (existingRecordId) {
      record[3] = { value: existingRecordId };
    }

    const data = {
      to: 'buz6rhchu',
      data: [record],
    };

    // Step 5: Upload to QuickBase
    const response = await quickbaseApi.post('/records', data);
    console.log('✅ Payout Request uploaded to QuickBase:', response.data);

    return {
      data: response.data,
      recordId:
        response.data?.metadata?.createdRecordIds?.[0] ||
        response.data?.metadata?.updatedRecordIds?.[0] ||
        null,
    };
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || error.message || 'Unknown error occurred';
    console.error('❌ Error uploading Payout Request to QuickBase:', errorMessage);
    throw new Error(errorMessage);
  }
};

export default UploadPayoutRequestToQuickBase;
